import { integer, object } from 'superstruct';
export const EditArcRoleBaseMemberDto = object({
  memberId: integer()
});